import Mock from 'mockjs'
const Random = require('mockjs').Random;

Mock.mock('http://localhost:8080/link',{
	code:1,
	 'list|50':[{
		 "number|1-100": 100,
		 'title':'@title',
		 'link':'www.baidu.com',
		 'logo':'logo',
	 }],
	 total:50
	
});
// banner设置
Mock.mock('http://localhost:8080/banner',{
	code:1,	
	 'list|50':[{
		 "number|1-100": 100,
		 'title':'@title',
		 'link':'www.baidu.com',
		 'logo':'logo',
	 }],
	 total:50
	
});
// 设置-banner设置
Mock.mock('http://localhost:8080/system/banner',{
	code:1,	
	 'list|50':[{
		 "number|1-100": 100,
		 "column":'新闻中心',
		 'title':'@title',
		 'link':'www.baidu.com',
		 'logo':'logo',
	 }],
	 total:50
	
});
// 设置-素材库设置
Mock.mock('http://localhost:8080/system/library',{
	code:1,	
	 'list|50':[{
		 "number|1-100": 100,
		 "name":'风景图',
		 'title':'@title',
		 "size":'5639kb',
		 'logo':'logo',
	 }],
	 total:50
	
});
// 内容管理-文章管理
Mock.mock('http://localhost:8080/content/art',{
	code:1,	
	 'list|10':[{
		 "number|1-100": 100,
		 'title':'@title',
		 "status|1":true,
		 'date':'@date("yyyy-MM-dd")',
		 'topping|1':true
	 }],
	 total:50
	
});
// 内容管理-图片管理
Mock.mock('http://localhost:8080/content/pic',{
	code:1,	
	 'list|10':[{
		 "number|1-100": 100,
		 'title':'@title',
		 "status|1":true,
		 'date':'@date("yyyy-MM-dd")',
		 'topping|1':true,
		 'logo':Random.image('40x40')
	 }],
	 total:50
	
});
// 内容管理-广告管理
Mock.mock('http://localhost:8080/content/advant',{
	code:1,	
	 'list|10':[{
		 "number|1-100": 100,
		 'title':'@title',
		 'content':'@cparagraph',
		 'topping|1':true,
		 'img':Random.image('40x40'),
		 'link':'www.baidu.com'
	 }],
	 total:50
	
});
// 内容管理-下载管理
Mock.mock('http://localhost:8080/content/down',{
	code:1,	
	 'list|10':[{
		 "number|1-100": 100,
		 'title':'@title',
		 "status|1":true,
		 'topping|1':true,
		'date':'@date("yyyy-MM-dd")',
	 }],
	 total:50
	
});
// 内容管理-留言管理
Mock.mock('http://localhost:8080/content/message',{
	code:1,	
	 'list|10':[{
		 "number|1-100": 100,
		 'name':'@cname',
		 "phone":'15698325698',
		 'email':'@email',
		'date':'@date("yyyy-MM-dd")',
	 }],
	 total:50
	
});
// 首页-日访问量
Mock.mock('http://localhost:8080/visits',{
	code:1,	
	'range': '@range(1, 10, 3)',
	 total:10
	
});


// WEBPACK FOOTER //
// ./src/assets/mock/mock.js